import { getSettings } from './settingsStorage'

const CHIME_PATH = '/sounds/wortelogy_chime.mp3'

let chime: HTMLAudioElement | null = null

/** Play the new-order chime from the start; restarts immediately if already playing. */
export function playNewOrderChime(): void {
  if (typeof window === 'undefined') return

  const volume = getSettings().newOrderChimeVolume
  if (volume <= 0) return

  try {
    if (!chime) {
      chime = new Audio(CHIME_PATH)
      chime.preload = 'auto'
    }
    chime.volume = Math.min(1, Math.max(0, volume))
    chime.pause()
    chime.currentTime = 0
    void chime.play().catch(() => {
      // Autoplay may be blocked until staff interact with the POS UI
    })
  } catch {
    // ignore missing file or unsupported environment
  }
}

/** Distinct two-tone alert for a print that failed after retries — not the new-order chime. */
export function playPrintFailChime(): void {
  if (typeof window === 'undefined') return
  const volume = getSettings().newOrderChimeVolume
  if (volume <= 0) return
  try {
    const Ctx = window.AudioContext || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext
    if (!Ctx) return
    const ctx = new Ctx()
    const gain = ctx.createGain()
    gain.gain.value = Math.min(1, Math.max(0, volume)) * 0.35
    gain.connect(ctx.destination)
    const beep = (freq: number, start: number, dur: number) => {
      const osc = ctx.createOscillator()
      osc.type = 'square'
      osc.frequency.value = freq
      osc.connect(gain)
      osc.start(ctx.currentTime + start)
      osc.stop(ctx.currentTime + start + dur)
    }
    beep(880, 0, 0.12)
    beep(660, 0.16, 0.16)
    void ctx.resume().catch(() => {})
  } catch {
    playNewOrderChime()
  }
}
